import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'home',
      path: '/',
      component: () => import('@/views/Home')
    },
    {
      name: 'builder',
      path: '/builder',
      props: true,
      component: () => import('@/views/Builder')
    },
    {
      name: 'categories',
      path: '/categories',
      component: () => import('@/views/Categories')
    },
    {
      name: 'menu',
      path: '/menu',
      component: () => import('@/views/Menu')
    },
    {
      name: 'account',
      path: '/account',
      props: true,
      component: () => import('@/views/Account')
    }
  ]
})